import { Button, MenuItem, Select, Stack } from "@mui/material"
import React from "react"
import { useState } from "react"
import BatchCard from "../cards/BatchCard"
import AcademicYearSelect from "../common/AcademicYearSelect"
import AddBatchModal from "../modals/AddBatchModal"
import FormItem from "../ui/FormItem"
import { getBatches } from "../../api"
import { useParams } from "react-router-dom"
import ListData from "../common/ListData"
import routes from "../../constants/routes"
import { Link } from "react-router-dom"

const BatchesTab = ({ data }) => {
  const [academicYear, setAcademicYear] = useState(2023)
  const [semester, setSemester] = useState(1)
  const [batchModal, setBatchModal] = useState(false)
  const { id } = useParams()

  const CTA = () => (
    <Stack
      direction="row"
      justifyContent="space-between"
      mb={2}
      alignItems="center"
    >
      <Stack direction="row" spacing={1}>
        <AcademicYearSelect value={academicYear} setValue={setAcademicYear} />{" "}
        <FormItem label="Semester" normalWidth>
          <Select
            size="small"
            name="semester"
            value={semester}
            onChange={(event) => {
              const { value } = event.target
              setSemester(value)
            }}
          >
            {[...Array((data?.numYear || 0) * 2).keys()].map((num) => (
              <MenuItem key={num + 1} value={num + 1}>
                {num + 1}
              </MenuItem>
            ))}
          </Select>
        </FormItem>
      </Stack>
      <Stack direction="row" spacing={2}>
        <Link to={`${routes.ACADEMIC.PROGRAMS}/${id}/create-schedule`}>
          <Button variant="outlined">Update Schedule</Button>
        </Link>
        <Button onClick={() => setBatchModal(true)} variant="contained">
          Add Batch
        </Button>
      </Stack>
    </Stack>
  )
  return (
    <>
      <ListData
        getAllData={getBatches}
        initialFilters={id && { filter: { programId: id } }}
        HeaderFull={CTA}
        Card={BatchCard}
        type="CARD"
        noView
        noFilterSort
      />
      <AddBatchModal
        isOpen={batchModal}
        close={() => setBatchModal(false)}
        currentProgramId={id}
        // refresh={fetchBatches}
        // openClassSchedule={openClassScheduleModal}
        currentAcademicYear={academicYear + "-" + (parseInt(String(academicYear).slice(-2)) + 1)}
        currentBatchDetails={data}
        currentSemester={semester}
      />
    </>
  )
}

export default BatchesTab
